module.exports = __webpack_public_path__ + "img/biaoqian_youeryuan.e31675c6.png";